import PropTypes from 'prop-types';
import TemplateCard from './TemplateCard';
import { EmptyState } from '../common';

/**
 * Grille de modèles de sondages
 * @component
 */
function TemplateGrid({ templates, onPreview, onUse }) {
  if (templates.length === 0) {
    return (
      <EmptyState
        icon="surveys"
        title="Aucun modèle disponible"
        description="Aucun sondage brouillon n'a été créé pour le moment."
      />
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {templates.map((template) => (
        <TemplateCard
          key={template.id}
          template={template}
          onPreview={onPreview}
          onUse={onUse}
        />
      ))}
    </div>
  );
}

TemplateGrid.propTypes = {
  templates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      category: PropTypes.string,
      questions: PropTypes.array,
    })
  ).isRequired,
  onPreview: PropTypes.func.isRequired,
  onUse: PropTypes.func.isRequired,
};

export default TemplateGrid;
